import {combineReducers} from 'redux';
import settings from './settings';
import uploadedCsvData from './uploaded-csv-data';
import csvLineups from './csv-lineups';
import simplexLineups from './simplex-lineups';
import lineupViews from './lineup-views';
import usedPlayers from './used-players';
import createdLineupsMap from './created-lineups-map';
import groupSameLineups from './group-same-lineups';

const reducers = {
    settings,
    uploadedCsvData,
    csvLineups,
    simplexLineups,
    lineupViews,
    usedPlayers,
    createdLineupsMap,
    groupSameLineups,
};

export default combineReducers(reducers);
